import { gql } from '@apollo/client';

export default {
    FETCH_M_SOSHIKI_DIVISIONS: gql`
        query FETCH_M_SOSHIKI_DIVISIONS($lgcode: String!, $createdYear: Int!, $processCd: Int = 30) {
            pdca_m_soshiki_division(
                where: { lgcode: { _eq: $lgcode }, _is_deleted: { _eq: false }, _is_hidden: { _eq: false } }
                order_by: { division_cd: asc }
            ) {
                id
                division_cd
                division_name
            }
            pdca_m_seisaku_shisaku(
                where: { lgcode: { _eq: $lgcode }, _is_deleted: { _eq: false } }
                order_by: { seisaku_shisaku_cd: asc }
            ) {
                id
                parent_cd
                seisaku_shisaku_cd
                seisaku_shisaku_name
                level
                m_keikaku_id
            }
            pdca_m_keikaku(where: { lgcode: { _eq: $lgcode } }) {
                id
                keikaku_name
            }
            pdca_t_pdca(
                where: {
                    lgcode: { _eq: $lgcode }
                    created_year: { _eq: $createdYear }
                    process_cd: { _eq: $processCd }
                    _is_deleted: { _eq: false }
                }
            ) {
                id
                m_soshiki_division_id_main
                t_jigyo {
                    id
                    c_jimu_jigyo_seisaku_shisakus(where: { _is_deleted: { _eq: false } }) {
                        id
                        m_seisaku_shisaku_id
                    }
                }
            }
        }
    `,
};
